import React from 'react';
import { Textarea as Textarea$1 } from '@chakra-ui/react';
var Textarea = function Textarea(props) {
  return /*#__PURE__*/React.createElement(Textarea$1, props);
};
Textarea.displayName = "Textarea";
export { Textarea };